export const TakeOverTestIds = {
  component: 'takeover-component',
  main: 'takeover-main',
};
